// Copy + formatting for the eBay sold-lane banner (Quote Assessment). Pure; no React.
// Voice: lead with what happened, name a checkable date, UK house style for dates
// ("Tuesday 18 August, 9.54pm"), no em dashes, no exclamation marks.

export function formatUkDateTime(iso, tz = 'Europe/London') {
    if (!iso) return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    const day = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'long', day: 'numeric', month: 'long' }).format(d);
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: 'numeric', minute: '2-digit', hour12: true }).formatToParts(d);
    const part = (type) => parts.find(p => p.type === type)?.value ?? '';
    const hour = part('hour');
    const minute = part('minute');
    const period = part('dayPeriod').toLowerCase().replace(/\./g, '');
    return `${day}, ${hour}${minute === '00' ? '' : '.' + minute}${period}`;
}

export function soldLaneBannerCopy(status) {
    if (!status || status.state !== 'tripped') return null;
    const when = formatUkDateTime(status.last_good_search_at);
    if (!when) {
        return 'No eBay sold comps at the moment. Quotes priced while it is down use asking prices and Reverb sales only, so check them before you send.';
    }
    return `No eBay sold comps since ${when}. Quotes priced since then use asking prices and Reverb sales only, so check them before you send.`;
}
